import React from "react";

import { OrdersPolaris2 } from "../../components/order/OrdersPolaris2";
import { ORDER_FILTER_SELLER_SUPPLIER } from "../../constants";
import { getPathFromRouter } from "../../helper";
import { USER_ROLE } from "../../variable";

export const OrdersSupplierPagePolaris2 = (...props) => {
  const path = getPathFromRouter(props);

  return (
    <OrdersPolaris2
      role={USER_ROLE.Seller}
      ordersFilter={ORDER_FILTER_SELLER_SUPPLIER}
      path={path}
    />
  );
};
